Object.defineProperty(exports, Symbol.toStringTag, {
  value: 'Module'
});

// This is a magic string replaced by rollup

var SDK_VERSION = "9.21.0";
exports.SDK_VERSION = SDK_VERSION;